module.exports = __webpack_public_path__ + "static/img/plate.23523a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s28/pop/plate.png
// module id = vfoz
// module chunks = 2